function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import Box from '../Box';
import { FormGroupContext } from './FormGroup';
const Checkbox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    field,
    form,
    hasError: _hasError,
    label,
    sx,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: "input",
    id: useContext(FormGroupContext)
  }, field, props, {
    type: "checkbox",
    __css: {
      mr: '6px'
    }
  }));
});
Checkbox.propTypes = {};
Checkbox.defaultProps = {};
Checkbox.displayName = 'Checkbox';
export default Checkbox;